import App from './App.svelte';
const app = new App({
    target: document.body,
    props: {
        header: 'Do not worry!',
        body: 'This is just a placeholder name!',
    }
});
export default app;
